import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";

import SvgIcon from "@mui/material/SvgIcon";

import {featureInterface} from "../../../../../interfaces/featureInterface";
import {GroheLockIconSmall} from "../../../../common/icons";
import {pricingIsLocked} from "../../lookNavigationFunctions";
import {getCurrentLayout} from "../../../../appLayout";
import {setLookOverlayOpened} from "../../../../../actions/lookFunctions";
import {LOOK_OVERLAYS} from "../../../core/constants";

const LookFeaturePriceLocked = (props) => {

  const {lookFeature, lockedText, setLookOverlayOpened} = props;

  let {showPrice} = pricingIsLocked();
  if (showPrice && lookFeature) {
    const layout = getCurrentLayout();
    showPrice = layout.partIdExistInQtCategory(lookFeature.partId);
  }

  const handlePriceLockClick = () => {
    console.log("lookFeature", lookFeature);
    setLookOverlayOpened(LOOK_OVERLAYS.leadCapture);
  };

  return (
    <span className={"grohe-price-locked" + (showPrice ? " grohe-price-locked--with-price" : "")} onClick={handlePriceLockClick}>
      <SvgIcon className="grohe-price-locked__icon">
        <GroheLockIconSmall/>
      </SvgIcon>
      <span className="grohe-price-locked__text">
        <FormattedMessage id={lockedText || (showPrice ? "grohe.feature.priceLocked" : "grohe.feature.locked")}/>
      </span>
    </span>
  )

};

LookFeaturePriceLocked.propTypes = {
  lookFeature: PropTypes.shape(featureInterface),
  lockedText: PropTypes.string,
}

const mapStateToProps = (store) => {
  return {
    fabricatorData: store.fabricatorState,
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookFeaturePriceLocked)
)
